module.exports = __webpack_public_path__ + "img/edge_activites_rando_courte.432dd7d6.svg";